import { getCookieConsent, setCookieConsent } from '@/persistence/cookie';

export interface CookieConsent {
  status:
    | 'unknown' // 用户没有选择接受 Cookie 也没有选择拒绝 Cookie
    | 'accept' // 用户接受了 Cookie
    | 'reject'; // 用户拒绝了 Cookie
}

export const getGdprState = () => {
  const cookieConsentValue = getCookieConsent();
  const cookieConsent: CookieConsent = {
    status: 'unknown',
  };

  if (typeof cookieConsentValue === 'string') {
    cookieConsentValue
      .trim()
      .split('&')
      .forEach((pair) => {
        const parts = pair.split('=');
        const key = parts.shift();
        const val = parts.join('=');
        if (typeof key === 'string') {
          cookieConsent[key as keyof CookieConsent] = val as any;
        }
      });
  }

  return cookieConsent;
};

export const setGdprState = (cookieConsent: CookieConsent) => {
  const values: string[] = [];

  for (const key in cookieConsent) {
    if (Object.prototype.hasOwnProperty.call(cookieConsent, key)) {
      values.push(`${key}=${cookieConsent[key as keyof CookieConsent]}`);
    }
  }

  if (cookieConsent.status === 'accept') {
    setCookieConsent(values.join('&'), 365);
  } else {
    setCookieConsent(values.join('&'));
  }
};
